<div
  class="card standalone validate-email-component"
  [ngClass]="{
    'show': isReady()
  }"
>
  <div class="card-header text-center">
    <h1 class="mb-0">
      {{'validate-email.title'|translate}}
    </h1>
  </div>
  <form
    [formGroup]="sendEmailForm"
    (ngSubmit)="sendEmail()"
    *ngIf="showSendEmailForm()"
  >
    <div class="card-body pb-0">
      <app-duke-alert
        type="info"
        alertClass="mb-0"
      >
        <p>
          {{'validate-email.info.key-sent-copy'|translate}}
        </p>
        <p>
          {{'validate-email.info.resend-key-copy'|translate}}
        </p>
<!--        <div
          class="form-group"
          *ngIf="email"
        >
          <div class="">
            <div class="input-group">
              suppress HtmlFormInputWithoutLabel 
              <input
                id="email"
                name="email"
                readonly
                type="text"
                formControlName="email"
                class="form-control"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-info"
                  type="submit"
                >{{'validate-email.info.resend-key-button.label'|translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="!email"
          class="clearfix"
        >
          <button
            class="btn btn-info float-right"
            type="submit"
          >{{'validate-email.info.resend-key-button.label'|translate}}
          </button>
        </div>-->
      </app-duke-alert>
      <app-duke-alert
        type="success"
        *ngIf="emailsent"
        dismissible="true"
        (open)="alertHandler.onOpen($event);"
        (close)="alertHandler.onClose($event); emailsent = false;"
      >
        <p class="mb-0">
          {{'validate-email.info.key-sent-notification'|translate}}
        </p>
      </app-duke-alert>
      <app-duke-alert
        type="danger"
        *ngIf="emailfailed"
        dismissible="true"
        (open)="alertHandler.onOpen($event);"
        (close)="alertHandler.onClose($event); emailfailed = false;"
      >
        <p class="mb-0">
          {{'validate-email.info.key-send-failed-notification'|translate}}
        </p>
      </app-duke-alert>
      <hr/>
    </div>
  </form>
  <form
    [formGroup]="validationForm"
    (ngSubmit)="submit()"
  >
    <div
      class="card-body"
      [ngClass]="{'pt-0': showSendEmailForm()}"
    >
<!--      <div
        app-form-input
        field="key"
        size="lg"
        label="{{'validate-email.key.label'|translate}}"
        [isInvalid]="isFieldInvalid(validationForm.get('key'))"
        [isValid]="isFieldValid(validationForm.get('key'))"
      >
        <div
          app-form-input-feedback
          type="invalid"
          *ngIf="!validationCodeExpired && isFieldInvalid(validationForm.get('key'))"
        >{{'validate-email.key.error-message.required-or-invalid'|translate}}</div>
        <div
          app-form-input-feedback
          type="invalid"
          *ngIf="validationCodeExpired && isFieldInvalid(validationForm.get('key'))"
        >{{'validate-email.key.error-message.expired'|translate}}</div>
      </div>-->
      <app-duke-alert
        type="danger"
        *ngIf="hasError()"
        alertClass="mb-0"
        dismissible="true"
        (open)="alertHandler.onOpen($event);"
        (close)="alertHandler.onClose($event); genericError = false;"
      >
        <p class="mb-0">
          {{'validate-email.submit-error.message'|translate}}
        </p>
      </app-duke-alert>
    </div>
    <div class="card-footer">
<!--      <div class="d-flex align-items-center flex-row-reverse">
        <span
          class="text-danger order-2 mr-2"
          *ngIf="hasError()"
          [@cardFooterFeedbackTransition]
        >
          <span class="icon fa fa-fw fa-exclamation-triangle"></span>
          <span>
            {{'validate-email.submit-error.notification'|translate}}
          </span>
        </span>
        <button
          class="btn btn-success"
          type="submit"
          [disabled]="!validationForm.valid"
        >
          {{'validate-email.validate-button.label'|translate}}
        </button>
      </div>-->
    </div>
  </form>
</div>
